import { useTranslation } from "../../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import { sectionClass } from "../../config/sectionClasses.js";
import { Reveal } from "../Reveal.jsx";
import { sectionHeaderClass } from "../../config/sectionClasses.js";
import { LottieAnimation } from "../LottieAnimation.jsx";
function About() {
  let { t: translate } = useTranslation();
  return (
    <section className={`${sectionClass} About_aboutSection__NpW-2`}>
      <Reveal>
        <div className={sectionHeaderClass}>
          <h2>{translate("home.about.title")}</h2>
        </div>
      </Reveal>
      <div className={"About_aboutBody__NpW-2"}>
        <Reveal className={"About_aboutTextReveal__NpW-2"}>
          <div className={"About_aboutText__NpW-2"}>
            <p>{translate("home.about.p1")}</p>
            <p>{translate("home.about.p2")}</p>
          </div>
        </Reveal>
        <Reveal>
          <LottieAnimation
            src={"lottie/lotus_15Token.json"}
            autoplay={true}
            playOnHover={true}
            playOnVisible={true}
            className={"About_aboutImage__NpW-2"}
          />
        </Reveal>
      </div>
    </section>
  );
}
export { About };
